import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import { STRIPE_OBJECT_TYPE_TOKEN } from 'common/stripeConstants';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';
import SrModalV2, {
  MODAL_THEME_FIXED_FOOTER_BUTTON,
  MODAL_THEME_FIXED_FOOTER_BUTTON_SLIDE_UP,
} from 'client/components/SrModalV2/SrModalV2';
import SrStripeCardForm from 'client/components/SrStripeCardForm';

const SrStripeCardFormModal = ({ stripeFee, inProgress, errorMessage, onCancel, onSource }) => {
  const submitStripeFormRef = useRef();

  const onStripeCardFormReady = (_onSubmitStripeForm) => {
    submitStripeFormRef.current = _onSubmitStripeForm;
  };

  const onConfirm = () => {
    submitStripeFormRef.current();
  };

  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  return (
    <SrModalV2
      theme={
        isSmallScreen ? MODAL_THEME_FIXED_FOOTER_BUTTON_SLIDE_UP : MODAL_THEME_FIXED_FOOTER_BUTTON
      }
      contentMaxWidth={!isSmallScreen ? '400px' : null}
      buttonContainerProps={{
        direction: 'col',
        rowGap: '18px',
      }}
      buttonProps={[
        {
          text: 'Confirm',
          theme: SR_BUTTON_THEME_ADOBE_GREEN,
          disabled: inProgress,
          onClick: onConfirm,
        },
        {
          text: 'Cancel',
          theme: SR_BUTTON_THEME_ADOBE_GREY,
          disabled: inProgress,
          onClick: onCancel,
        },
      ]}
      onClose={onCancel}
    >
      <SrBox margin="4px 15px 14px 15px">
        <SrBox>
          <SrText
            color="blueGreycliff"
            font="greycliff"
            fontSize="30px"
            lineHeight="36px"
            weight="800"
          >
            Pay with a card
          </SrText>
        </SrBox>
        <SrStripeCardForm
          buttonHidden
          objectType={STRIPE_OBJECT_TYPE_TOKEN}
          submitErrorMessage={errorMessage}
          onReady={onStripeCardFormReady}
          onSubmit={onSource}
        />
        <SrBox>
          <SrText font="whitney-sc" weight="600" display="block">
            convenience fee: ${stripeFee}
          </SrText>
          <SrText weight="500" paddingTop="10px" display="block">
            Please note that there will be a convenience fee added to your total when paying by
            card.
          </SrText>
        </SrBox>
      </SrBox>
    </SrModalV2>
  );
};

SrStripeCardFormModal.propTypes = {
  stripeFee: PropTypes.number.isRequired,
  inProgress: PropTypes.bool,
  errorMessage: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onSource: PropTypes.func.isRequired,
};

SrStripeCardFormModal.displayName = 'SrStripeCardFormModal';

export default SrStripeCardFormModal;
